module.exports = __webpack_public_path__ + "media/images/Stanford-Logo-e52407c1813bcf9b02db03b7df74dc14.png";